import { render, staticRenderFns } from "./PublicStartup.vue?vue&type=template&id=7f4478ae&scoped=true&"
import script from "./PublicStartup.vue?vue&type=script&lang=js&"
export * from "./PublicStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4478ae",
  null
  
)

export default component.exports